// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.etf_edition_header_box {
  border-bottom: solid 1px #ccc;
  margin: 30px 0;
}

.etf_edition_form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 100%;
}

.etf_edition_button_box {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.etf_edition_button_submit {
  padding: 7px 20px;
  border-radius: 4px;
  background-color: var(--primary);
  border: solid 1px var(--primary);
  color: white;
  width: 100px;
  justify-content: end;
}

.etf_edition_button_submit:disabled {
  background-color: var(--primary-50);
  border: solid 1px var(--primary);
}

.etf_edition_search_container {
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 15px;
  width: 90%;
}

.etf_edition_search_container_input {
  max-width: 100%;
  border: 1px solid var(--border);
  padding: 10px 15px;
  border-radius: 4px;
  width: 90%;
}

.etf_edition_search_input {
  position: relative;
}

 .etf_edition_search_container {
  margin-bottom: 2rem;
} 

.relative {
  position: relative;
}

.etf_edition_search_delete_selected_item {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background-color: var(--primary);
  border-radius: 50%;
  color: #fff;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.etf_edition_search_tickers_list_box {
  position: absolute;
  background-color: var(--bg-card);
  max-width: 90%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  max-height: 650px;
  overflow-y: scroll;
  width: 100%;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 4px;
}

.etf_edition_search_ticker_selected {
  max-width: 100%;
  border: 1px solid var(--border);
  padding: 5px 10px;
  border-radius: 4px;
  background-color: var(--bg);
}

.etf_edition_search_ticker_not_selected {
  max-width: 100%;
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid var(--border);
}

.etf_edition_search_ticker_not_selected :hover {
  background-color: var(--bg);
}

.etf_edition_search_ticker_selected p,
.etf_edition_search_ticker_not_selected p {
  margin: 0;
  padding: 0;
}

.etf_edition_search_format {
  font-size: 17px;
}

.etf_edition_result_search {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.etf_edition_alert_repartition_box {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.etf_edition_alert_repartition {
  color: var(--danger);
}`, "",{"version":3,"sources":["webpack://./src/pages/actifs/subpages/EtfEdition/etfEdition.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;CAEC;EACC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".etf_edition_header_box {\n  border-bottom: solid 1px #ccc;\n  margin: 30px 0;\n}\n\n.etf_edition_form {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-width: 100%;\n}\n\n.etf_edition_button_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.etf_edition_button_submit {\n  padding: 7px 20px;\n  border-radius: 4px;\n  background-color: var(--primary);\n  border: solid 1px var(--primary);\n  color: white;\n  width: 100px;\n  justify-content: end;\n}\n\n.etf_edition_button_submit:disabled {\n  background-color: var(--primary-50);\n  border: solid 1px var(--primary);\n}\n\n.etf_edition_search_container {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  gap: 15px;\n  width: 90%;\n}\n\n.etf_edition_search_container_input {\n  max-width: 100%;\n  border: 1px solid var(--border);\n  padding: 10px 15px;\n  border-radius: 4px;\n  width: 90%;\n}\n\n.etf_edition_search_input {\n  position: relative;\n}\n\n .etf_edition_search_container {\n  margin-bottom: 2rem;\n} \n\n.relative {\n  position: relative;\n}\n\n.etf_edition_search_delete_selected_item {\n  position: absolute;\n  right: 5px;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  background-color: var(--primary);\n  border-radius: 50%;\n  color: #fff;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.etf_edition_search_tickers_list_box {\n  position: absolute;\n  background-color: var(--bg-card);\n  max-width: 90%;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  max-height: 650px;\n  overflow-y: scroll;\n  width: 100%;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  padding: 10px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n}\n\n.etf_edition_search_ticker_selected {\n  max-width: 100%;\n  border: 1px solid var(--border);\n  padding: 5px 10px;\n  border-radius: 4px;\n  background-color: var(--bg);\n}\n\n.etf_edition_search_ticker_not_selected {\n  max-width: 100%;\n  padding: 5px 10px;\n  border-radius: 4px;\n  border: 1px solid var(--border);\n}\n\n.etf_edition_search_ticker_not_selected :hover {\n  background-color: var(--bg);\n}\n\n.etf_edition_search_ticker_selected p,\n.etf_edition_search_ticker_not_selected p {\n  margin: 0;\n  padding: 0;\n}\n\n.etf_edition_search_format {\n  font-size: 17px;\n}\n\n.etf_edition_result_search {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.etf_edition_alert_repartition_box {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n}\n\n.etf_edition_alert_repartition {\n  color: var(--danger);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
